import * as React from "react";
import { useEffect, useRef, useState } from "react";

const tolerance = 2;

export default function PPDetailsMoreBlock({ headItem }) {
  const [isPrintOpen, setIsPrintOpen] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const descriptionRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const element = descriptionRef.current;
      if (!element) return;

      const lineHeight = parseFloat(
        window.getComputedStyle(element).lineHeight
      );
      const maxHeight = lineHeight * 5;
      setIsTruncated(element.scrollHeight > maxHeight + tolerance);
    };

    checkOverflow();
    const observer = new ResizeObserver(checkOverflow);
    if (descriptionRef.current) {
      observer.observe(descriptionRef.current);
    }

    return () => observer.disconnect();
  }, [headItem.description]);

  useEffect(() => {
    window.onbeforeprint = () => setIsPrintOpen(true);

    window.onafterprint = () => setIsPrintOpen(false);

    return () => {
      window.onbeforeprint = null;
      window.onafterprint = null;
    };
  }, []);

  if (isPrintOpen) {
    return (
      <p className="product-intro-description">
        <span>{headItem.description}</span>
      </p>
    );
  }

  return (
    <p
      className={`product-intro-description ${
        showFullDescription ? "expanded" : ""
      }`}
    >
      <span
        ref={descriptionRef}
        className={!showFullDescription ? "description-text" : ""}
      >
        {headItem.description}
      </span>

      {isTruncated && (
        <a
          className={showFullDescription ? "show-less" : ""}
          onClick={() => setShowFullDescription(true)}
        >
          Read full description
        </a>
      )}

      {showFullDescription && (
        <a onClick={() => setShowFullDescription(false)}>View Less</a>
      )}
    </p>
  );
}
